export const SELECT_REPORT_STRING = 'Select Report';
export const SELECT_DESTINATION_STRING = 'Select Destination';
